import { render, staticRenderFns } from "./active-invasions-list.vue?vue&type=template&id=929ef1f6&scoped=true&lang=pug&"
import script from "./active-invasions-list.vue?vue&type=script&lang=js&"
export * from "./active-invasions-list.vue?vue&type=script&lang=js&"
import style0 from "./active-invasions-list.vue?vue&type=style&index=0&id=929ef1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929ef1f6",
  null
  
)

export default component.exports